module.exports = __webpack_public_path__ + "static/media/marginalia-bad-gateway.a9fed34d.svg";